import { configureStore } from "@reduxjs/toolkit"
import { wishSlice } from "../slices/wishSlice"
import { StoreState } from "./StoreState"
import { settingsSlice } from "@/slices/settingsSlice"

export const store = configureStore<StoreState>({
  reducer: {
    wish: wishSlice.reducer,
    settings: settingsSlice.reducer,
  },
})
